import { z } from 'zod';
import { JsonObjectSchema } from '@/lib/zod';

/**
 * Zod schema for the kiosk localStorage entry (key: 'kiosk').
 * Validated on every read; invalid or missing data coerces to null.
 */
export const KioskStorageSchema = JsonObjectSchema.pipe(
  z
    .object({
      pairingToken: z.string().nullable(),
    })
    .nullable(),
);

export type KioskStorage = z.infer<typeof KioskStorageSchema>;
